var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame27(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 969,
    height: 498,
    viewBox: "0 0 969 498",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_1228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1124.8 133.228L1088.62 280.509C987.076 338.485 867.571 410.085 778.947 399.732C625.79 382.281 747.015 213.298 692.128 207.88C637.221 201.517 279.702 506.079 173.646 489.49C2.42784 480.939 168.123 236.323 102.734 233.969C66.1976 232.876 -46.0493 328.89 -157.274 427.717L-104.205 217.691C-70.2898 186.708 -47.6937 165.423 -47.6937 165.423C-47.6937 165.423 133.261 3.64275 254.765 23.6746C376.269 43.7064 175.266 299.489 293.869 318.639C413.452 338.713 761.05 -24.2293 878.96 7.22212C962.296 39.4279 861.116 202.303 921.444 236.901C962.399 264.36 1064.27 177.079 1124.8 133.228Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_1228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 969,
    height: 498,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame27);
export default __webpack_public_path__ + "static/media/Frame27.a544b60b499e341b8ad5a5a0022a0856.svg";
export { ForwardRef as ReactComponent };